module.exports = __webpack_public_path__ + "img/chevron-left.77b87181.svg";